import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineDownloadAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M8.29 13.29a1.001 1.001 0 0 0-.2958.71 1.0003 1.0003 0 0 0 .2958.71l3 3a.9997.9997 0 0 0 1.42 0l3-3a1.0041 1.0041 0 1 0-1.42-1.42L13 14.59V3a1.0002 1.0002 0 0 0-1.7071-.7071A1.0002 1.0002 0 0 0 11 3v11.59l-1.29-1.3a1.001 1.001 0 0 0-.71-.2958.9994.9994 0 0 0-.71.2958ZM18 9h-2a1 1 0 1 0 0 2h2a1.0001 1.0001 0 0 1 1 1v7a1.0001 1.0001 0 0 1-1 1H6a1.0002 1.0002 0 0 1-1-1v-7a1 1 0 0 1 1-1h2a1.0002 1.0002 0 0 0 .7071-1.7071A1 1 0 0 0 8 9H6a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a3.0002 3.0002 0 0 0-3-3Z"/>
  </SvgIcon>
}

export default LineDownloadAltIcon
